import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { formatDate } from '../lib/format';

interface TemplateSummary {
  type: string;
  label: string;
  audience: 'customer' | 'owner';
  description: string;
  customized: boolean;
  updated_at: string | null;
  updated_by: string | null;
}

export function Emails() {
  const [templates, setTemplates] = useState<TemplateSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ templates: TemplateSummary[] }>('/api/admin/emails')
      .then((d) => setTemplates(d.templates))
      .catch((err) => setError(err.message));
  }, []);

  if (!templates) return <p>{error ?? 'Loading…'}</p>;

  const groups: { title: string; audience: TemplateSummary['audience'] }[] = [
    { title: 'Sent to customers', audience: 'customer' },
    { title: 'Sent to you', audience: 'owner' },
  ];

  return (
    <div style={{ maxWidth: 900 }}>
      <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 28, fontWeight: 400 }}>Emails</h1>
      <p style={muted}>
        Edit the subject and wording of the emails the shop sends. Changes apply to emails sent from about a
        minute after you save; you can reset any email to its original version.
      </p>

      {groups.map((g) => (
        <section key={g.audience} style={card}>
          <h2 style={h2}>{g.title}</h2>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 12, fontSize: 14 }}>
            <tbody>
              {templates
                .filter((t) => t.audience === g.audience)
                .map((t) => (
                  <tr key={t.type} style={{ borderTop: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '12px 0' }}>
                      <Link to={`/emails/${t.type}`} style={{ color: '#1a1a1a', fontWeight: 500 }}>
                        {t.label}
                      </Link>
                      <div style={{ ...muted, margin: '2px 0 0' }}>{t.description}</div>
                    </td>
                    <td style={{ padding: '12px 0', textAlign: 'right', whiteSpace: 'nowrap' }}>
                      {t.customized ? (
                        <span title={t.updated_by ? `by ${t.updated_by}` : undefined} style={badgeCustom}>
                          Edited {formatDate(t.updated_at)}
                        </span>
                      ) : (
                        <span style={badgeDefault}>Original</span>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </section>
      ))}
    </div>
  );
}

const card: React.CSSProperties = {
  background: '#fff',
  border: '1px solid #e5e5e5',
  borderRadius: 8,
  padding: 24,
  marginTop: 16,
};
const h2: React.CSSProperties = { fontFamily: 'Georgia, serif', fontSize: 20, fontWeight: 400, margin: 0 };
const muted: React.CSSProperties = { fontSize: 12, color: '#6b7280', margin: '6px 0 0' };
const badgeDefault: React.CSSProperties = { fontSize: 12, color: '#6b7280' };
const badgeCustom: React.CSSProperties = {
  fontSize: 12,
  color: '#1e40af',
  background: '#eff6ff',
  borderRadius: 10,
  padding: '2px 10px',
};
